import { RescheduleItemType } from "@myapp/contract";

const RESCHEDULE_TYPE_LABELS: Record<RescheduleItemType, string> = {
  APPOINTMENT: "Termin",
  TASK: "Aufgabe",
};

export const getRescheduleTypeLabel = (type: RescheduleItemType): string =>
  RESCHEDULE_TYPE_LABELS[type];

const RESCHEDULE_TYPE_COLORS: Record<RescheduleItemType, string> = {
  APPOINTMENT: "#2EB5D9",
  TASK: "#ED9E42",
};

export const getRescheduleTypeColor = (type: RescheduleItemType): string =>
  RESCHEDULE_TYPE_COLORS[type];
